import axios from 'axios';
import router from './routes';
import auth from './service/auth'

axios.defaults.timeout = 30000;
// interceptor de request
axios.interceptors.request.use(async function(config) {
  // Si es un presigned URL a S3 (virtual-hosted o path-style), no tocar headers:
  const url = (config.url || '').toString();
  const isS3Presigned =
    url.includes('.s3.') ||            // https://<bucket>.s3.<region>.amazonaws.com/...
    url.includes('s3.amazonaws.com/'); // https://s3.amazonaws.com/<bucket>/...

  if (isS3Presigned) {
    // No agregues Authorization, ni pises Content-Type.
     config.timeout = 0;
    return config;

  }

  // --- el resto de tu lógica para tus APIs internas ---
  if (config.headers['Content-Type'] === 'audio/wav') return config;
  if (config.headers['Authorization']) return config;

  const run = localStorage.getItem(`CognitoIdentityServiceProvider.${process.env.VUE_APP_COGNITO_CLIENT_ID}.LastAuthUser`);
  const auth_token = localStorage.getItem(`CognitoIdentityServiceProvider.${process.env.VUE_APP_COGNITO_CLIENT_ID}.${run}.idToken`);

  if (auth_token) config.headers['Authorization'] = `Bearer ${auth_token}`;

  // OJO: solo pone estos defaults para tus APIs, no para S3.
  if (!config.headers['Content-Type']) {
    config.headers['Content-Type'] = 'application/json';
  }
  config.headers['Accept'] = 'application/json; charset=utf-8';

  return config;
}, function(err) {
  return Promise.reject(err);
});


axios.interceptors.response.use(
    function (response)
    {

        if(response.data.statusCode == 403)
        {
            return router.push({path: '/unauthorized'})

        }

        if (response.status === 200 || response.status === 201)
            return Promise.resolve(response)


        return Promise.reject(response)
    },
    function (error)
    {
        // console.log("error:: ", error)

        if (!error.request || !error.response) {
            // Manejar errores de red o de otro tipo donde request/response pueden no estar definidos
            console.error("Error en la solicitud:", error);
            return Promise.reject(error);
        }

        if (error.request.status !== 401)
            return new Promise((resolve, reject) => reject(error))

        if ([401, 403].indexOf(error.request.status) !== -1)
        {
            console.log("The incoming token has expired")
            router.push({path: '/logout'})
        }

        return Promise.reject(error)
    }
  );

